import React from "react";
import { Box, Typography, Chip } from "../../ui-kit";
import { useStyles } from "./RejectedCard.styles";

export interface RejectedCardProps {
  label: string;
  fileName: string;
  thumbnailUrl?: string;
  reasons: string[];
  className?: string;
}

const RejectedCard = ({ label, fileName, thumbnailUrl, reasons, className }: RejectedCardProps) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <Typography className={classes.label}>{label}</Typography>
      <Box className={classes.card}>
        <Box className={classes.cardRow}>
          <Box className={classes.thumbnail}>
            {thumbnailUrl && <img src={thumbnailUrl} alt={label} />}
          </Box>
          <Typography className={classes.fileName}>{fileName}</Typography>
          <Chip label="Rejected" size="small" className={classes.badge} />
        </Box>
        {reasons.length > 0 && (
          <Box className={classes.reasonsList}>
            <Typography className={classes.reasonsTitle}>Rejection Reasons</Typography>
            {reasons.map((r) => (
              <Typography key={r} className={classes.reasonItem}>{r}</Typography>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RejectedCard;
